import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { listSourceMappings, replaceSourceMappings } from './sourceMappingApi'
import type { SourceMappingRow } from './sourceMappingApi'

export const sourceMappingKeys = {
  list: (cfg: string, src: string) => ['configuration-source-mappings', cfg, src] as const,
}

export function useSourceMappings(cfg: string, src: string) {
  return useQuery({
    queryKey: sourceMappingKeys.list(cfg, src),
    queryFn: () => listSourceMappings(cfg, src),
    enabled: !!cfg && !!src,
  })
}

export function useReplaceSourceMappings(cfg: string, src: string) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (rows: SourceMappingRow[]) => replaceSourceMappings(cfg, src, rows),
    onSuccess: () => qc.invalidateQueries({ queryKey: sourceMappingKeys.list(cfg, src) }),
  })
}
